/* src/components/pdf-page-risk-rainbow/pdf-page-risk-rainbow.component.scss */
app-pdf-page-risk-rainbow {
  display: block;
}
.pdf-sortable-label {
  height: 9pt;
  width: 9pt;
}
/*# sourceMappingURL=pdf-page-risk-rainbow.component-BPFKALIP.css.map */
